var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-view-container"},[(_vm.hasRender)?_c('div',{staticClass:"spinner-container"},[_c('spinner',{attrs:{"color":"#333333"}})],1):_vm._e(),_c('vue-pdf-embed',{attrs:{"source":"/terms.pdf"},on:{"rendered":_vm.rendered}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }